import React from "react";

function StoryLeft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g
        id="Left_Story_Icon"
        data-name="Left Story Icon"
        transform="translate(0)"
      >
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="15"
          cy="15"
          r="15"
          transform="translate(0)"
          fill="rgba(255,255,255,0.86)"
          opacity="0.5"
        />
        <path
          id="Icon_akar-chevron-left"
          data-name="Icon akar-chevron-left"
          d="M16.5,6,13.25,9.25,10.5,12l6,6"
          transform="translate(1.75 2.75)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default StoryLeft;
